export type { FlagProps } from './flag';
export { default } from './flag';
